module.exports = __webpack_public_path__ + "img/payment.9c7ec55e.svg";